import type { loader as layoutLoader } from '~/routes/_layout'
import type { MetaFunction } from 'react-router'

export const meta: MetaFunction<Record<string, never>, { layout: typeof layoutLoader }> = ({ matches }) => {
  const layoutData = matches.find(m => m.id === 'layout')?.data
  const companyName = layoutData?.orgDetails?.companyName ?? 'Webshop'
  const canonicalUrl = layoutData?.canonicalUrl ? `${layoutData.canonicalUrl}/shipping-returns` : undefined

  const title = `Verzending & Retourneren | ${companyName}`
  const description = 'Informatie over verzendkosten, levertijden, verzendmethoden en ons retourbeleid. Gratis verzending mogelijk.'

  const articleJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    url: canonicalUrl,
    inLanguage: 'nl-NL',
    author: { '@type': 'Organization', name: companyName },
    publisher: { '@type': 'Organization', name: companyName },
    dateModified: '2025-01-01'
  }

  return [
    { title },
    { name: 'description', content: description },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:type', content: 'article' },
    { property: 'og:url', content: canonicalUrl },
    { property: 'og:locale', content: 'nl_NL' },
    { name: 'twitter:card', content: 'summary' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'robots', content: 'index, follow' },
    { tagName: 'link', rel: 'canonical', href: canonicalUrl },
    { 'script:ld+json': articleJsonLd }
  ]
}

export default function ShippingReturns() {
  return <div className="mx-auto flex w-full max-w-5xl flex-1 p-4 text-(--ws-text) lg:p-2 lg:pt-4">Shipping & Returns</div>
}
